<ngb-toast
  *ngFor="let toast of toastService.toasts$ | async"
  [class]="toast.classname"
  [autohide]="true"
  [delay]="toast.delay || 5000"
  [animation]="toast.animation || true"
  [header]="toast.header || ''"
  (hidden)="toastService.remove(toast)"
  [@inOutToast]
>
  <ng-template [ngIf]="toast.template" [ngIfElse]="text">
    <ng-template [ngTemplateOutlet]="toast.template || null"></ng-template>
  </ng-template>

  <ng-template #text>
    <div class="d-flex justify-content-between">
      <div>{{ toast.text }}</div>
      <span
        *ngIf="toast.closeable"
        class="bi bi-x-lg cursor-pointer"
        (click)="toastService.remove(toast)"
      ></span>
    </div>
  </ng-template>
</ngb-toast>
